<template>
	<svg
		width="31px"
		height="46px"
		viewBox="0 0 31 46"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="microphone on icon"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g
				transform="translate(-773.000000, -464.000000)"
				:fill="color"
				fill-rule="nonzero"
			>
				<g transform="translate(532.000000, 242.000000)">
					<g transform="translate(201.000000, 206.000000)">
						<path
							d="M55.5107422,46.1171875 C59.7861328,46.1171875 62.6650391,42.9160156 62.6650391,38.3398438 L62.6650391,23.9667969 C62.6650391,19.3691406 59.7861328,16.1894531 55.5107422,16.1894531 C51.2138672,16.1894531 48.3349609,19.3691406 48.3349609,23.9667969 L48.3349609,38.3398438 C48.3349609,42.9160156 51.2138672,46.1171875 55.5107422,46.1171875 Z M65.0927734,61.9511719 C65.9951172,61.9511719 66.7255859,61.2421875 66.7255859,60.3398438 C66.7255859,59.4375 65.9951172,58.7070312 65.0927734,58.7070312 L57.1220703,58.7070312 L57.1220703,53.7011719 C65.3291016,53.0136719 70.8720703,47.1054688 70.8720703,38.6835938 L70.8720703,34.3222656 C70.8720703,33.4199219 70.1630859,32.7109375 69.2607422,32.7109375 C68.3583984,32.7109375 67.6279297,33.4199219 67.6279297,34.3222656 L67.6279297,38.5546875 C67.6279297,45.8808594 62.8583984,50.7363281 55.5107422,50.7363281 C48.1416016,50.7363281 43.3720703,45.8808594 43.3720703,38.5546875 L43.3720703,34.3222656 C43.3720703,33.4199219 42.6630859,32.7109375 41.7392578,32.7109375 C40.8369141,32.7109375 40.1279297,33.4199219 40.1279297,34.3222656 L40.1279297,38.6835938 C40.1279297,47.1054688 45.6923828,53.0136719 53.8779297,53.7011719 L53.8779297,58.7070312 L45.9072266,58.7070312 C45.0048828,58.7070312 44.2744141,59.4375 44.2744141,60.3398438 C44.2744141,61.2421875 45.0048828,61.9511719 45.9072266,61.9511719 L65.0927734,61.9511719 Z"
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MicOn',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
}
</script>
